import { render, staticRenderFns } from "./GoodsBargainDetails.vue?vue&type=template&id=2cc99b1a&scoped=true"
import script from "./GoodsBargainDetails.vue?vue&type=script&lang=js"
export * from "./GoodsBargainDetails.vue?vue&type=script&lang=js"
import style0 from "./GoodsBargainDetails.vue?vue&type=style&index=0&id=2cc99b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc99b1a",
  null
  
)

export default component.exports